<template>
  <div class="bet-slip mt-1 open-bets-tab border-bottom-0">
    <div v-if="!status.loading">
      <open-bets-tab-row v-for="(bet, index) in data" :key="'open:' + index" :openbet="bet"></open-bets-tab-row>
    </div>
    <div v-if="data.length === 0 && status.success" class="empty-bet-slip text-uppercase">
      {{ $t('BetSlip.EmptyOpenBets') }}
    </div>
    <div v-if="status.loading" class="text-center mt-4">
      <loading-icon :white="true"></loading-icon>
    </div>
    <div class="pt-1" v-if="data.length > 0 && showMoreButton">
      <router-link to="/history?openbets=1" v-on:click.native="toggleBetSlip">
        <button class="btn-open-bets btn btn-large" :class="$isElectron ? '' : 'btn-light'">
          {{ $t('BetSlip.All Open Bets') }}
        </button>
      </router-link>
    </div>
  </div>
</template>

<script>
import OpenBetsTabRow from './OpenBetsTabRow';
import LoadingIcon from '@/components/shared/LoadingIcon';
import {mapMutations} from "vuex";

export default {
  components: {
    OpenBetsTabRow,
    LoadingIcon,
  },
  props: ['status', 'data', 'showMoreButton'],
  methods: {
    ...mapMutations({
      toggleBetSlip: 'betSlip/toggleBetSlip',
    }),
  }
};
</script>

<style lang="scss">
@import '../../../../sass/variables';
@import '../../../../sass/mixins/_mixins';

.open-bets-tab {
  background-color: transparent !important;

  > div {
    background: $color-4;
  }

  .open-bet-row {
    &-header {
      background-color: #ffffff;
      padding: 5px 10px;
      cursor: pointer;
      transition: all 0.2s ease-in-out;

      .title {
        font-size: 0.95rem;
        color: $color-1;
        font-weight: bold;
      }

      .subtitle {
        font-size: 0.7rem;
        color: rgba($active-color-bg, 0.3);
      }

      &.active,
      &:hover {
        background-color: $color-2;
        color: $color-3 !important;

        .title {
          color: $color-3 !important;
        }
      }
    }

    &-subheader {
      background-color: #eee;
      font-size: 0.75rem;
      color: var(--color9);
      text-transform: uppercase;
      font-weight: bold;
    }

    &-detail-row {
      border-bottom: 1px solid #e6edf1;

      .line-number {
        background-color: $active-color-bg;
        color: #fff;
        padding: 2px 5px;
        font-weight: 600;
      }

      .line-date {
        color: $secondary-bg-color;
        font-weight: 600;
        font-size: 11.5px;
      }

      .line-detail {
        color: #232234;
        font-size: 0.8rem;
        font-weight: 600;
      }
    }
  }
}
</style>
